import { render, staticRenderFns } from "./BaseSearchFormFooter.vue?vue&type=template&id=64c988a1&"
import script from "./BaseSearchFormFooter.vue?vue&type=script&lang=js&"
export * from "./BaseSearchFormFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports